import {
  Component,
  OnInit,
} from '@angular/core';
import { AccountService } from '../shared/account/account.service'

@Component({
  selector: 'logout',
  templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {
  
  constructor(private accountService: AccountService) {  }

  ngOnInit(): void {
    this.accountService.remoteLogout();
  }
}